import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { ReportSectionTypes } from '../redux/constants';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from '../ReportPage.scss';
const ReportFooter = ({ isCancelVisible, isBackVisible, isDMCAVisible, isNextVisible, isNextDisabled, isSubmitVisible, deviationId, onBack, onCancel, onNext, onSubmit })=>{
    const isMobile = useContext(MobileContext);
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("footer", null, isCancelVisible && !isMobile && /*#__PURE__*/ React.createElement(TextButton, {
        size: "medium",
        variant: "main",
        className: s['button'],
        onClick: onCancel
    }, t('common.cancel')), isBackVisible && /*#__PURE__*/ React.createElement(TextButton, {
        size: "medium",
        variant: "main",
        className: s['button'],
        onClick: onBack
    }, t('common.back')), isNextVisible && /*#__PURE__*/ React.createElement(GhostButton, {
        size: "large",
        variant: "approval-green",
        className: s['button'],
        disabled: isNextDisabled,
        onClick: onNext
    }, t('pagination.next')), isSubmitVisible && /*#__PURE__*/ React.createElement(SolidButton, {
        className: s['button'],
        size: "large",
        variant: "approval-green",
        onClick: onSubmit
    }, t('common.submit')), isDMCAVisible && /*#__PURE__*/ React.createElement(SolidButton, {
        className: s['button'],
        size: "large",
        variant: "approval-green",
        href: Url.contactDmcaHolderLink(),
        target: "_blank",
        biData: BiData({
            evid: 29,
            type_chosen: ReportSectionTypes.FirstPartyIp,
            deviationid: deviationId
        })
    }, t('moderation.fileDMCA')));
};
ReportFooter.displayName = 'ReportFooter';
export default ReportFooter;

//# sourceMappingURL=ReportFooter.js.map